import { responseValidator } from '../../helpers/helpers'
import { IChatMessage } from '../../interfaces/interfaces'
import { apiCaller } from '../../services/apiCaller'
import { API } from '../../services/services'
import { setMessageCount, setMessages, setSocket, setUsersInfoInChat } from '../slices/chatSlice'
import store from '../store'
import { ChatType } from 'interfaces'
import { toast } from "mobin-toast"
import { getAllChatMessages, submitChatComment } from './videoData.actions'
import io from "socket.io-client";

export const handleGetUsersInChat = async (user_ids: string[]) => {
  const { data, status } = await apiCaller({ url: API().user.profile, method: 'POST', data: { user_ids: user_ids } })
  if (responseValidator(status)) return data.data
  else return []
}

export const submitCommentInChat = async (message: string, setInputValue: (value: string) => void) => {
  const { roomId, chatType } = store.getState().chats
  const { userId } = store.getState().user
  const _data = {
    room: roomId,
    text: message,
  }
  const { data, status } = await submitChatComment(_data);
  if (responseValidator(status)) {
    if (chatType !== ChatType.public) toast({
      title: 'پیام شما با موفقیت ثبت شد و پس از تایید، نمایش داده خواهد شد.',
      type: 'success',
    })
  } else toast({ title: 'ارتباط با سرور دچار مشکل شده است.', type: 'error' })
  setInputValue('')
}

export const fetchChatMessage = async (offset: number, setScrollEnd: any) => {
  const { roomId, messages, messageCount } = store.getState().chats
  const dispatch = store.dispatch
  const { data, status } = await getAllChatMessages(roomId, offset);
  if (responseValidator(status)) {
    setScrollEnd(false);
    let messChat:any[] = [];
    if (messageCount !== 0) {
      if (messages) {
        messChat = [...messages, ...data.results]; 
      } else {
        messChat = [...data.results];
      }
    }
    else messChat = [...data.results];
    dispatch(setMessageCount(data.count))
    handleFirstTimeChatRoomMessage(messChat)
  }
}

export const handleConnectSocket = (setScrollEnd: any) => {
  const dispatch = store.dispatch
  const { roomId } = store.getState().chats
  let socket: any
  socket = io(API().live.liveChat.chat(roomId))
  socket.on('connect', async () => {
    dispatch(setSocket(socket))
    fetchChatMessage(0, setScrollEnd)
    socket.on('message', async (data: IChatMessage[] | IChatMessage) => handleChatRoomMessage(data))
  })
}

export const handleChatRoomMessage = async (data: IChatMessage[] | IChatMessage) => {
  const dispatch = store.dispatch
  const { messages } = store.getState().chats
  if (!Array.isArray(data)) {
    const { usersInfoInChat } = store.getState().chats
    if (messages && messages.length) dispatch(setMessages([data, ...messages]))
    else dispatch(setMessages([data]))
    if (!usersInfoInChat.find((user: any) => user.user_id === data.author)) {
      const userInfoData = await handleGetUsersInChat([data.author])
      if (userInfoData.length) dispatch(setUsersInfoInChat([...usersInfoInChat, ...userInfoData]))
    }
  }
}

export const handleFirstTimeChatRoomMessage = async (data: IChatMessage[]) => {
  const dispatch = store.dispatch
  if (data.length) {
    dispatch(setMessages(data))
    let user_ids: string[] = []
    data.map((item: IChatMessage) => user_ids.push(item.author))
    user_ids = [...new Set(user_ids)]
    const userInfoData = await handleGetUsersInChat(user_ids)
    if (userInfoData.length) dispatch(setUsersInfoInChat(userInfoData))
  } else dispatch(setMessages([]))
}